import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.string.trim.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/icons/close_btn.svg';
var _hoisted_1 = {
  class: "title"
};
var _hoisted_2 = {
  class: "body"
};
var _hoisted_3 = {
  key: 0,
  class: "item"
};
var _hoisted_4 = {
  class: "label"
};
var _hoisted_5 = {
  key: 1,
  class: "item"
};
var _hoisted_6 = {
  class: "label"
};
var _hoisted_7 = {
  key: 2,
  class: "item"
};
var _hoisted_8 = {
  class: "label"
};
var _hoisted_9 = {
  key: 3,
  class: "tip"
};
var _hoisted_10 = {
  class: "btn-container"
};
import { onMounted } from "vue";
import { ref } from "vue";
import { useUserStore } from "@/store/userStore";
import Button from "@/components/base/Button.vue";
import BirthdayChange from "./BirthdayChange.vue";
import { Field } from "vant";
import { updateUserInfo, getUserDetail } from "@/api/user";
import { PHONE_BINDED } from "@/constant/responseCode";
import { Notify } from "@/utils/notifyUtil";
import { showToast } from "@/utils/toastUtil";
import { isPhoneAccount } from "@/components/login/mobile/helper";
import dayjs from "dayjs";
import { useI18n } from "vue-i18n";
export default {
  __name: 'UserInfoInputPopup',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    onSuccess: {
      type: Function,
      default: function _default() {
        return {};
      }
    },
    onError: {
      type: Function,
      default: function _default() {
        return {};
      }
    }
  },
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var userStore = useUserStore();
    var props = __props;
    var showPopup = ref(false);
    var form = ref({
      nickname: "",
      telephone: "",
      birthday: ""
    });
    var handleChangeBirthday = function handleChangeBirthday(birthday) {
      form.value.birthday = birthday;
    };
    function checkParams() {
      if (!userStore.getUserInfo.nickname && !form.value.nickname.trim()) {
        showToast(t("pleaseInputName"));
        return;
      }
      if (!userStore.getUserInfo.telephone && !isPhoneAccount(form.value.telephone)) {
        showToast(t("wrongFormatOfPhoneNumber"));
        return;
      }
      if (!userStore.getUserInfo.birthday && !form.value.birthday) {
        showToast(t("pleaseSelectYourBirthday"));
        return;
      }
      return true;
    }
    function handleSave() {
      return _handleSave.apply(this, arguments);
    }
    function _handleSave() {
      _handleSave = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params, birthDay, res, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (checkParams()) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              params = {};
              if (form.value.birthday) {
                birthDay = dayjs.tz(form.value.birthday).startOf("days").valueOf();
                params.birthday = birthDay;
              }
              if (form.value.nickname) {
                params.name = form.value.nickname;
              }
              if (form.value.telephone) {
                params.phone = form.value.telephone;
              }
              _context.next = 8;
              return updateUserInfo(_objectSpread(_objectSpread({}, params), {}, {
                customer_id: userStore.getUserInfo.customer_id
              }));
            case 8:
              res = _context.sent;
              if (!res.isOK) {
                _context.next = 18;
                break;
              }
              showPopup.value = false;
              showToast(t("successfully"));
              _context.next = 14;
              return getUserDetail();
            case 14:
              result = _context.sent;
              if (result.isOK) {
                userStore.setUserInfo(result.data);
              }
              _context.next = 19;
              break;
            case 18:
              if (res.code === PHONE_BINDED) {
                Notify.error(t("mobilePhoneNumberHasBeenBound"));
              }
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _handleSave.apply(this, arguments);
    }
    onMounted(function () {
      if (props.show) {
        showPopup.value = true;
      }
    });
    return function (_ctx, _cache) {
      var _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createBlock(_component_van_popup, {
        show: showPopup.value,
        "onUpdate:show": _cache[3] || (_cache[3] = function ($event) {
          return showPopup.value = $event;
        }),
        class: "account-info-input-container",
        "safe-area-inset-bottom": "",
        round: "",
        position: "bottom",
        "lazy-render": false,
        "close-on-click-overlay": false
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createTextVNode(_toDisplayString(_ctx.$t("myProfile")) + " ", 1), _createElementVNode("img", {
            class: "close",
            src: _imports_0,
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return showPopup.value = false;
            })
          })]), _createElementVNode("div", _hoisted_2, [!_unref(userStore).getUserInfo.nickname ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("name")), 1), _createVNode(_unref(Field), {
            modelValue: form.value.nickname,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return form.value.nickname = $event;
            }),
            class: "field",
            clearable: "",
            placeholder: _ctx.$t('input'),
            maxlength: "20",
            "input-align": "right"
          }, null, 8, ["modelValue", "placeholder"])])) : _createCommentVNode("", true), !_unref(userStore).getUserInfo.telephone ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("phone")), 1), _createVNode(_unref(Field), {
            modelValue: form.value.telephone,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return form.value.telephone = $event;
            }),
            class: "field",
            clearable: "",
            placeholder: _ctx.$t('input'),
            type: "number",
            maxlength: "20",
            "input-align": "right"
          }, null, 8, ["modelValue", "placeholder"])])) : _createCommentVNode("", true), !_unref(userStore).getUserInfo.birthday ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("birthday")), 1), _createVNode(BirthdayChange, {
            class: _normalizeClass(["placeholder", {
              value: !!form.value.birthday
            }]),
            trigger: "manual",
            value: form.value.birthday,
            onChange: handleChangeBirthday
          }, null, 8, ["value", "class"])])) : _createCommentVNode("", true), !_unref(userStore).getUserInfo.birthday ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t("notModifyBirthday")), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_10, [_createVNode(Button, {
            class: "btn",
            onClick: handleSave
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("save")), 1)];
            }),
            _: 1
          })])];
        }),
        _: 1
      }, 8, ["show"]);
    };
  }
};